import React, { useState } from "react";
import "./fastivelCalander.css";

const PanchangWidget = () => {
  const [city, setCity] = useState("Delhi");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]); // yyyy-mm-dd

  // Convert date to DD-MM-YYYY format
  const formatDate = (inputDate) => {
    const d = new Date(inputDate);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getIframeUrl = () => {
    const formattedDate = formatDate(date);
    const encodedCity = encodeURIComponent(city);
    return `https://www.mypanchang.com/newsite/compactfeed.php?pt=12pt&mode=FULL&city=${encodedCity}&date=${formattedDate}`;
  };

  return (
    <div className="panchang-container">
      <h2>Panchang Calendar (Location & Date Based)</h2>

      <div className="panchang-select-wrapper">
        <label htmlFor="city-select">City:</label>
        <select id="city-select" value={city} onChange={(e) => setCity(e.target.value)}>
          <option value="Delhi">Delhi</option>
          <option value="Mumbai">Mumbai</option>
          <option value="Kolkata">Kolkata</option>
          <option value="Chennai">Chennai</option>
          <option value="Bengaluru">Bengaluru</option>
        </select>
      </div>

      <div className="panchang-select-wrapper">
        <label htmlFor="date-select">Date:</label>
        <input
          type="date"
          id="date-select"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>

      <div className="panchang-iframe-wrapper">
        <iframe
          title="Panchang Calendar"
          name="newpanchang"
          id="newpanchang"
          key={getIframeUrl()} // force iframe refresh on src change
          src={getIframeUrl()}
          scrolling="no"
          frameBorder="0"
          style={{ width: "100%", border: "0" }}
          allowtransparency="true"
        ></iframe>
      </div>
    </div>
  );
};

export default PanchangWidget;
